export default __webpack_public_path__ + "static/media/bg-hero-section-2.32f28da4.svg";